<template>
  <div class="contact-us-wrapper">
    <div class="title-wrapper"></div>
    <div class="flex map-container">
      <div class="map-body" :center="center" :zoom="zoom" :scroll-wheel-zoom="true" @ready="readyHanlder" style="position: relative">
        <img src="../../assets/images/maps.jpg" style="position: absolute;left: 0;top: 0;width: 110%;">
      </div>
      <div class="map-info" v-if="currentInfo.name">
        <p style="color: #e26b23;font-size:1.2vw;font-weight: bold;margin-bottom:5px">维迈股份有限公司</p>
        <p class="title">{{ currentInfo.name.zh }}</p>
        <div class="item">
          <img class="icon" src="../../assets/images/contact-us/icon-10.png" alt="" />
          <p>{{ currentInfo.address.zh }}</p>
        </div>
        <!-- <div class="item">
          <img
            src="../../assets/images/contact-us/icon-12.png"
            class="icon"
            alt=""
          />
          <p>{{ currentInfo.contact.zh }}</p>
        </div> -->
        <div class="item">
          <img src="../../assets/images/contact-us/icon-11.png" class="icon" alt="" />
          <p>{{ currentInfo.mobile }}</p>
        </div>
        <div class="item">
          <img src="../../assets/images/contact-us/icon-12.png" class="icon" alt="" />
          <p>{{ currentInfo.email }}</p>
        </div>
        <div class="item">
          <img src="../../assets/images/contact-us/icon-13.png" class="icon" alt="" />
          <img style="width: 150px" src="../../assets/images/home/ewm.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//坐标拾取 https://api.map.baidu.com/lbsapi/getpoint/index.html
//background-image: url("https://fhc-web-1301696124.cos.ap-shanghai.myqcloud.com/clinicalNetwork/clinicList8.jpg");
import { listCompany } from '@/api'

export default {
  data() {
    return {
      center: { lng: 108.94589, lat: 39.883027 },
      zoom: 5,
      show: false,
      currentInfo: {},
      list: []
    }
  },
  mounted() {
    this.readyHanlder();
  },
  methods: {
    readyHanlder() {
      listCompany().then(ret => {
        let { result } = ret
        this.list = result.map(c => {
          return {
            ...c,
            lng: c.lng_lat.split(',')[0],
            lat: c.lng_lat.split(',')[1],
            showInfoWindow: false
          }
        })
        this.list[0].showInfoWindow = true
        this.currentInfo = this.list[0]
      })
    },
    showWindow(info) {
      info.showInfoWindow = true
      this.currentInfo = info
    }
  }
}
</script>

<style lang="less">
.contact-us-wrapper {
  background-color: white;
  padding-top: 2vh;
  min-height: 110vh;

  .title-wrapper {
    font-size: 28px;
    font-weight: bold;
    width: 18vw;
    color: white;
    height: 7vh;
    margin: auto;
    line-height: 7vh;
    padding-left: 2.5vw;
    font-size: 2vw;
    // background: url('../../assets/images/木牌.png') no-repeat;
    background-size: cover;
    background-origin: center;
    background-position: center;
  }

  .map-container {
    height: 75vh;
    margin-top: 5vh;

    .map-body {
      width: 65vw;
      height: 100%;

      .BMap_Marker>div>img {
        max-width: 100%;
        height: auto;
      }

      .bm-info-wrapper {
        padding: 0px 0;
        width: 300px;

        img {
          width: 300px;
          margin-top: 10px;
          object-fit: cover;
        }

        p {
          margin-top: 10px;
          color: #333333;
        }
      }
    }

    .map-info {
      transform: scale(0.7);
      padding: 4vh 2vw 0;

      .title {
        line-height: 1.5;
        padding-bottom: 2vh;
        border-bottom: 1px solid rgba(204, 204, 204, 1);
        color: #e26b23;
        font-size: 1.2vw;
        font-weight: bold;
        margin-bottom: 5vh;
      }

      .item {
        padding-left: 8px;
        font-size: 1vw;
        line-height: 1.5;
        margin-bottom: 3vh;
        display: flex;
        align-items: center;

        .icon {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }

        p:first-child {
          color: #333333;
        }

        p:last-child {
          color: #666666;
        }
      }
    }
  }
}
</style>
